import { ItemPreference } from "../../../../repositories/interfaces";

export function orderPreferences(preferences: ItemPreference[]) {
  return preferences.sort(function (a, b) {
    return preferencesDefaultOrder?.indexOf(a.key) - preferencesDefaultOrder?.indexOf(b.key);
  });
}

// The fieldOptions preferences are removed because the only one needed to the comparison is the "field-options" preference, wich is an stringified array of objects.
function orderAndRemoveDuplicatedOptionPreference(preferences: ItemPreference[]): ItemPreference[] {
  const preferencesCopy = [...preferences];

  const filteredPreferences = preferencesCopy.filter(preference => preference.key.toLowerCase() !== "fieldoptions");  

  orderPreferences(filteredPreferences);
  return filteredPreferences;
}

/**
 * @param currentPreferences - The current list of item preferences to compare (current state of the preferences before saving the form).
 * @param originalPreferences - The original list of item preferences to compare against (original state of the preferences).
 * @returns `true` if the ordered and filtered preferences are equal, otherwise `false`.
 */
export function orderAndComparePreferences(currentPreferences: ItemPreference[], originalPreferences: ItemPreference[]) {
  const orderedCurrentPrefs = orderAndRemoveDuplicatedOptionPreference(currentPreferences);
  const orderedOriginalPrefs = orderAndRemoveDuplicatedOptionPreference(originalPreferences);
  
  for (const preference of orderedOriginalPrefs) {
    const key = preference.key;
    const currentPreference = orderedCurrentPrefs.find(pref => pref.key === key);
    //It does not consider the case where we don't find the preference in the currentPreferences -> this never happens according to the field saving logic
    if (currentPreference?.value !== preference.value && currentPreference?.key !== "FieldOptions") {
      return false; // Value mismatch
    }
  }
  return true; 
}


const preferencesDefaultOrder = [
  "Title",
  "Titledescription", 
  "Automatic",
  "Mandatory",
  "EquipmentMRK",
  "ListItemsDropdown",
  "Checklistvalue",
  "ListItemsRadio",
  "FixedListItemsDropdown",
  "Filter",
  "Fieldid",
  "Qrorbarcode",
  "Isnumberinteger",
  "Min",
  "Max",
  "DecimalPlacesMin",
  "Fieldsinformdescription"
];
